// src/pages/LoginPage.js
import React, { useState } from "react";

const PRIMARY = "#1F2937";

export default function LoginPage() {
  const [view,    setView]    = useState("choose"); // "choose" | "external"
  const [email,   setEmail]   = useState("");
  const [sending, setSending] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState("");

  async function handleMagicRequest(e) {
    e.preventDefault();
    const trimmed = email.trim().toLowerCase();
    if (!trimmed) return;

    // Prevent SUFC staff from using the external flow
    if (trimmed.endsWith("@sufc.co.uk")) {
      setError("Sheffield United staff should use the 'Sign in with Microsoft 365' button above.");
      return;
    }

    setSending(true); setError("");
    try {
      const res  = await fetch("/api/auth/request", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: trimmed }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Request failed");
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  }

  return (
    <div style={{ minHeight:"100vh", background:"#F3F4F6", display:"flex", alignItems:"center", justifyContent:"center", padding:24, fontFamily:"'Segoe UI',system-ui,sans-serif" }}>
      <div style={{ width:"100%", maxWidth:440 }}>

        {/* Logo */}
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ display:"inline-flex", alignItems:"center", justifyContent:"center", width:64, height:64, background:PRIMARY, borderRadius:18, marginBottom:14, boxShadow:"0 4px 16px rgba(31,41,55,0.3)" }}>
            <svg viewBox="0 0 20 20" fill="white" width="34">
              <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3z"/>
              <path d="M9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0z"/>
            </svg>
          </div>
          <h1 style={{ fontSize:22, fontWeight:700, color:"#111827", margin:0 }}>SUFC Online Training Portal</h1>
          <p style={{ fontSize:14, color:"#6B7280", marginTop:6 }}>Sign in to access your training</p>
        </div>

        <div style={{ background:"#fff", borderRadius:16, boxShadow:"0 4px 24px rgba(0,0,0,0.08)", padding:28 }}>

          {/* Choose view */}
          {view === "choose" && (
            <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
              <p style={{ fontSize:14, color:"#6B7280", marginBottom:4, textAlign:"center", lineHeight:1.6 }}>
                How would you like to sign in?
              </p>

              {/* M365 button */}
              <a href="/.auth/login/aad?post_login_redirect_uri=/"
                style={{ display:"flex", alignItems:"center", gap:14, background:PRIMARY, color:"#fff", textDecoration:"none", padding:"14px 20px", borderRadius:12, fontWeight:600, fontSize:15, transition:"opacity 0.15s" }}
                onMouseEnter={e=>e.currentTarget.style.opacity="0.9"}
                onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                <svg viewBox="0 0 21 21" width="22" fill="none">
                  <path d="M10 0H0v10h10V0z" fill="#F25022"/>
                  <path d="M21 0H11v10h10V0z" fill="#7FBA00"/>
                  <path d="M10 11H0v10h10V11z" fill="#00A4EF"/>
                  <path d="M21 11H11v10h10V11z" fill="#FFB900"/>
                </svg>
                <span>Sign in with Microsoft 365</span>
                <span style={{ marginLeft:"auto", fontSize:12, opacity:0.7 }}>@sufc.co.uk</span>
              </a>

              {/* Divider */}
              <div style={{ display:"flex", alignItems:"center", gap:12 }}>
                <div style={{ flex:1, height:1, background:"#E5E7EB" }}/>
                <span style={{ fontSize:13, color:"#9CA3AF" }}>or</span>
                <div style={{ flex:1, height:1, background:"#E5E7EB" }}/>
              </div>

              {/* External button */}
              <button
                onClick={() => setView("external")}
                style={{ display:"flex", alignItems:"center", gap:14, background:"#F9FAFB", color:PRIMARY, border:"1.5px solid #E5E7EB", padding:"14px 20px", borderRadius:12, fontWeight:600, fontSize:15, cursor:"pointer", textAlign:"left", transition:"border-color 0.15s, background 0.15s" }}
                onMouseEnter={e=>{ e.currentTarget.style.background="#F3F4F6"; e.currentTarget.style.borderColor="#D1D5DB"; }}
                onMouseLeave={e=>{ e.currentTarget.style.background="#F9FAFB"; e.currentTarget.style.borderColor="#E5E7EB"; }}>
                <svg viewBox="0 0 20 20" fill={PRIMARY} width="22">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                </svg>
                <span>Sign in with an External Email</span>
                <span style={{ marginLeft:"auto", fontSize:12, color:"#9CA3AF" }}>One-time link</span>
              </button>
            </div>
          )}

          {/* External email flow */}
          {view === "external" && !sent && (
            <div>
              <button onClick={() => { setView("choose"); setError(""); setEmail(""); }}
                style={{ background:"none", border:"none", cursor:"pointer", fontSize:13, color:"#6B7280", display:"flex", alignItems:"center", gap:4, marginBottom:18, padding:0 }}>
                ← Back
              </button>
              <h3 style={{ fontSize:17, fontWeight:700, color:"#111827", marginBottom:6 }}>External email sign-in</h3>
              <p style={{ fontSize:14, color:"#6B7280", marginBottom:20, lineHeight:1.6 }}>
                Enter the email address you were invited with. We'll send you a secure one-time login link.
              </p>
              <form onSubmit={handleMagicRequest}>
                <label style={{ display:"block", fontSize:13, fontWeight:600, color:"#374151", marginBottom:6 }}>Email address</label>
                <input
                  type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="your@email.com" required autoFocus
                  style={{ width:"100%", padding:"11px 14px", fontSize:14, border:`1.5px solid ${error?"#DC2626":"#D1D5DB"}`, borderRadius:10, outline:"none", boxSizing:"border-box", marginBottom:error?6:14 }}
                />
                {error && <div style={{ fontSize:13, color:"#DC2626", marginBottom:12 }}>{error}</div>}
                <button type="submit" disabled={sending || !email.trim()}
                  style={{ width:"100%", background:sending||!email.trim()?"#9CA3AF":PRIMARY, color:"#fff", border:"none", borderRadius:10, padding:"13px", fontSize:15, fontWeight:600, cursor:sending||!email.trim()?"not-allowed":"pointer" }}>
                  {sending ? "Sending…" : "Send Login Link"}
                </button>
              </form>
            </div>
          )}

          {/* Sent confirmation */}
          {view === "external" && sent && (
            <div style={{ textAlign:"center" }}>
              <div style={{ fontSize:52, marginBottom:14 }}>📧</div>
              <h3 style={{ fontSize:18, fontWeight:700, color:"#111827", marginBottom:8 }}>Check your inbox</h3>
              <p style={{ fontSize:14, color:"#6B7280", lineHeight:1.6, marginBottom:6 }}>
                If <strong>{email}</strong> is registered, a login link is on its way. It expires in <strong>1 hour</strong> and can only be used once.
              </p>
              <p style={{ fontSize:13, color:"#9CA3AF", marginBottom:20 }}>Check your spam folder if you don't see it.</p>
              <button onClick={() => { setSent(false); setEmail(""); setError(""); }}
                style={{ background:"none", border:"1.5px solid #E5E7EB", borderRadius:8, padding:"8px 18px", fontSize:13, color:"#6B7280", cursor:"pointer" }}>
                Try a different email
              </button>
            </div>
          )}
        </div>

        <p style={{ textAlign:"center", fontSize:12, color:"#9CA3AF", marginTop:20 }}>
          SUFC Online Training Portal — for access issues contact IT support
        </p>
      </div>
    </div>
  );
}
